// Note, constants are replaced right after tsc built the project.
// Update scripts/post-build.ts when requirements here change.
export const pkg = {
    name: '@magicbell/magicbell-react',
    version: '11.5.1',
};
//# sourceMappingURL=pkg.js.map